import ApiService from "../api";

export default class LancamentoDespesaService extends ApiService {

    constructor() {
        super('/api/solicitacoes/lancamento-despesa')
    }

    criarSolicitacao(dados) {
        return this.post(``, dados)
    }

    buscarDetalhe(solicitacaoId) {
        return this.get(`/${solicitacaoId}`)
    }

    editarSolicitacao(solicitacaoId, dados) {
        return this.put(`/${solicitacaoId}`, dados)
    }

    relatorio(filtros = {}) {
        const params = new URLSearchParams();
        Object.entries(filtros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        return this.get(`/relatorio?${params}`);
    }

    dashboard(filtros = {}) {
        const params = new URLSearchParams();
        Object.entries(filtros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        return this.get(`/dashboard?${params}`);
    }
}
